// Hook for PathwayAlignmentSubmission component
export const usePathwayAlignmentSubmission = ({ assignment, student }) => {
	// Get response text from student data
	// response_text can be in student object directly or in student's assignment data
	const responseText =
		student?.response_text ||
		student?.responseText ||
		student?.assignmentData?.response_text ||
		assignment?.students?.find(s => s.id === student?.id)?.response_text ||
		''

	return {
		responseText,
		hasResponse: Boolean(responseText && responseText.trim()),
	}
}

export default usePathwayAlignmentSubmission
